export default __webpack_public_path__ + "static/media/banner-image_br.398417b8.jpg";